import React, { useState, useEffect } from 'react'
// COMPONENT ELEMENTS
import InputShadow from './../../elements/InputShadow'
// MODEL
import { MODEL_COLOR } from '../../../model/ModelColor'
// IMAGES
import imageCaseACocher from '../../../images/caseACocher.png'
import imageCaseACocherOk from '../../../images/caseACocherOk.png'
import ButtonModalClose from '../../elements/ButtonModalClose'


const ModalService = ({ handleChange, handleAddService, values, staff, services, count, setCount }) => { 
    const [valueTime, setValueTime] = useState('15')
    const [valueCase, setValueCase] = useState([])

    useEffect(() => { 
        setValueTime('15')
        setValueCase([])
    },[services])
    
    return (
        <div className="modal fade" id="modalService" >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalService">Ajouter un service</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => [setCount(count + 1), setValueCase([]), setValueTime('15')]}></button>
                    </div>
                    <div className="modal-body">
                        <div className='mt-3'>

                            {/* NAME SERVICE */}
                            <InputShadow name='nameService' value={values.nameService} placeholder="Ajouter un service" onChange={handleChange} />

                            {/* PRICE */}
                            <InputShadow name='priceService' value={values.priceService} placeholder="prix" onChange={handleChange} />

                            {/* DURÉE */}
                            <div className='text-center mt-3 mb-2'>Durée</div>
                            <div className='row text-center'>
                                <div 
                                    className='col border rounded mx-1' 
                                    style={valueTime === '15' ? {backgroundColor:MODEL_COLOR.blueApply } : {}}
                                    onClick={() => setValueTime('15')}
                                >15 min</div>
                                <div
                                    className='col border rounded mx-1' 
                                    style={valueTime === '30' ? {backgroundColor:MODEL_COLOR.blueApply } : {}}
                                    onClick={() => setValueTime('30')}   
                                >30 min</div>
                                <div 
                                    className='col border rounded mx-1'
                                    style={valueTime === '45' ? {backgroundColor:MODEL_COLOR.blueApply } : {}}
                                    onClick={() => setValueTime('45')} 
                                >45 min</div>
                                <div
                                    className='col border rounded mx-1'
                                    style={valueTime === '60' ? {backgroundColor:MODEL_COLOR.blueApply } : {}}
                                    onClick={() => setValueTime('60')}               
                                >1 h</div> 
                            </div>

                            <div className='row text-center mt-2'>
                                <div 
                                    className='col border rounded mx-1'
                                    style={valueTime === '75' ? {backgroundColor:MODEL_COLOR.blueApply } : {}}
                                    onClick={() => setValueTime('75')} 
                                >1h15</div>
                                <div 
                                    className='col border rounded mx-1'
                                    style={valueTime === '90' ? {backgroundColor:MODEL_COLOR.blueApply } : {}}
                                    onClick={() => setValueTime('90')} 
                                >1h30</div>
                                <div 
                                    className='col border rounded mx-1'
                                    style={valueTime === '105' ? {backgroundColor:MODEL_COLOR.blueApply } : {}}
                                    onClick={() => setValueTime('105')} 
                                >1h45</div>
                                <div 
                                    className='col border rounded mx-1'
                                    style={valueTime === '120' ? {backgroundColor:MODEL_COLOR.blueApply } : {}}
                                    onClick={() => setValueTime('120')} 
                                >2h</div>
                            </div>  

                            {/* STAFF */}
                            <div className='text-center mt-3'>Équipe</div>
                            {staff.map(st => (
                                <div key={st.id} className='p-2 mt-1'>
                                    <div className='row'>
                                        <div className='col-1' 
                                            onClick={() => 
                                                valueCase[st.id] ?   
                                                setValueCase(prev => ({...prev, [st.id]: false })) :
                                                setValueCase(prev => ({...prev, [st.id]: true  }))
                                            }
                                        >
                                            {valueCase[st.id] ? 
                                                <img src={imageCaseACocherOk} alt='image du logo' style={{ height:25, width:25 }} />
                                            : 
                                                <img src={imageCaseACocher} alt='image du logo' style={{ height:25, width:25 }} />
                                            }
                                        </div>
                                        <div className='col'>
                                            <div 
                                                key={st.id} 
                                            >{st.surnameStaff} {st.nameStaff}</div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {/* BUTTON ADD SERVICE */}
                            <ButtonModalClose
                                title='Enregistrer'
                                disabled={values.nameService && values.priceService && valueTime ? false : true}
                                onClick={() => handleAddService(values.nameService, values.priceService, valueTime, valueCase)}
                            />
                        </div>
                    </div> 
                </div>
            </div>
        </div>
    )
}

export default ModalService




